<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list
          @form="dialog = true"
          @view="view = true"
          @clear="$refs.form.clear()"
        />
        <form-manager ref="form" :dialog="dialog" @close="dialog = false" />
        <notification-view
          :dialog="view"
          @close="view = false"
          @clear="$refs.form.clear()"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormManager from './FormManager'
import List from './List'
import NotificationView from './NotificationView'

export default {
  name: 'Notifications',
  components: {
    List,
    FormManager,
    NotificationView,
  },
  data() {
    return {
      dialog: false,
      view: false,
    }
  },
  mounted() {
    this.$store.dispatch('notifications/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchNotifications: 'notifications/fetchList',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      await Promise.all([this.debounceFetch('notifications')])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
